import React from "react";
import { Card } from "react-bootstrap";

const UserMessagingShimmer = () => {
  return (
    <div className="d-flex flex-column flex-grow-1 p-4">

      {/* ===== Inline Shimmer CSS ===== */}
      <style>{`
        .shimmer {
          position: relative;
          overflow: hidden;
          background: #e9ecef;
          border-radius: 8px;
        }

        .shimmer::after {
          content: "";
          position: absolute;
          top: 0;
          left: -150px;
          height: 100%;
          width: 150px;
          background: linear-gradient(
            90deg,
            rgba(255,255,255,0) 0%,
            rgba(255,255,255,0.7) 50%,
            rgba(255,255,255,0) 100%
          );
          animation: shimmerMove 1.4s infinite;
        }

        @keyframes shimmerMove {
          0% { left: -150px; }
          100% { left: 100%; }
        }

        .shimmer-pulse {
          animation: pulseFade 1.6s ease-in-out infinite;
        }

        @keyframes pulseFade {
          0% { opacity: 0.6; }
          50% { opacity: 1; }
          100% { opacity: 0.6; }
        }
      `}</style>

      <Card className="flex-grow-1 d-flex flex-column border-0 shadow-sm">

        {/* ===== Header Skeleton ===== */}
        <Card.Header className="bg-white border-bottom p-3">
          <div className="mb-2 shimmer shimmer-pulse" style={{ height: 24, width: "45%" }} />
          <div className="mb-3 shimmer shimmer-pulse" style={{ height: 14, width: "30%" }} />
          <div className="mb-2 shimmer shimmer-pulse" style={{ height: 16, width: "70%" }} />
        </Card.Header>

        {/* ===== Chat Skeleton Area ===== */}
        <Card.Body className="flex-grow-1 overflow-auto bg-light">

          {/* Left Message */}
          <div className="d-flex mb-4">
            <div
              className="shimmer shimmer-pulse"
              style={{ height: 60, width: "45%", borderRadius: 12 }}
            />
          </div>

          {/* Right Message */}
          <div className="d-flex justify-content-end mb-4">
            <div
              className="shimmer shimmer-pulse"
              style={{ height: 70, width: "50%", borderRadius: 12 }}
            />
          </div>

          {/* Left Message */}
          <div className="d-flex mb-4">
            <div
              className="shimmer shimmer-pulse"
              style={{ height: 55, width: "40%", borderRadius: 12 }}
            />
          </div>

        </Card.Body>

        {/* ===== Input Skeleton ===== */}
        <Card.Footer className="bg-white border-top">
          <div className="d-flex gap-2">
            <div
              className="shimmer shimmer-pulse"
              style={{ height: 38, flex: 1, borderRadius: 6 }}
            />
            <div
              className="shimmer shimmer-pulse"
              style={{ height: 38, width: 90, borderRadius: 6 }}
            />
          </div>
        </Card.Footer>

      </Card>
    </div>
  );
};

export default UserMessagingShimmer;